export default __webpack_public_path__ + "static/media/snapchat-logo.aba26de4.jpg";